export default "__VITE_ASSET__0HmLmbPV__"